exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-box[data-v-75f787e8]{display:flex;flex-wrap:wrap;gap:10px}", ""]);

